import { render, staticRenderFns } from "./ListaHolerites.vue?vue&type=template&id=09d59e6a&"
import script from "./ListaHolerites.vue?vue&type=script&lang=js&"
export * from "./ListaHolerites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports